import { useLocation, useParams } from "react-router-dom"
import PunchRecordForm from "./PunchRecords"
import { get, getSelectedStaff } from "store/leave/punch-records"
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { BasePathProvider, useBasePath } from "components/Providers"
import RequestCorrectionForm from "./RequestCorrectionForm"
import { hasPermission } from "store"

export default function PunchRecordsFormIndex() {
  const { punchRecordId } = useParams()
  const dispatch = useDispatch()
  const basePath = useBasePath()
  const location = useLocation()
  const personId = location?.state?.personId
  const date = location?.state?.date
  const data = location?.state?.data
  const isCorrectionRequest = location?.state?.isCorrection
  const selectedTeacher = location?.state?.selectedTeacher

  const isAdmin = hasPermission('hr.leave') || hasPermission('leave.punch')

  const [recordDetail, setRecordDetail] = useState(null)

  useEffect(() => {
    if (punchRecordId) {
      const action = isAdmin
        ? getSelectedStaff({ personId, date })
        : get({ date })
      dispatch(action).then(res => {
        setRecordDetail(res.payload)
      })
    } else {
      setRecordDetail(null)
    }
  }, [dispatch, punchRecordId, personId, date])

  return (
    <BasePathProvider value={`${basePath}`}>
      {isCorrectionRequest
        ? <RequestCorrectionForm recordDetail={recordDetail} date={date} selectedTeacher={selectedTeacher} />
        : <PunchRecordForm recordDetail={recordDetail} date={date} data={data} personId={personId} />
      }
    </BasePathProvider>
  )
}
